import { SidebarTrigger } from '@/components/ui/sidebar';
import { SinoNotificacoes } from './SinoNotificacoes';

export function Header() {
  return (
    <header className="sticky top-0 z-20 flex h-14 shrink-0 items-center gap-2 bg-bg-main px-3 sm:h-16 sm:px-6">
      {/* Trigger: colapsa o rail (desktop) / abre o drawer (tablet) */}
      <SidebarTrigger />

      <div className="flex-1" />

      <SinoNotificacoes />
    </header>
  );
}
